<template>
  <div class="content">
    <div class="content_title">
      Добавить редакцию шаблона
    </div>
    <div class="form-row-line">
      <div class="form-field">
        <label for="org-select">Организация:</label>
        <select id="org-select" v-model="newContractType.COMPANY">
          <option
            v-for="(company, key) in companies"
            :key="key"
            :value="company.ID"
          >
            {{ company.SHORT_NAME }}
          </option>
        </select>
      </div>
      <div class="form-field">
        <label for="description-input">Причина создания редакции:</label>
        <input
          id="description-input"
          v-model="newContractType.DESCRIPTION"
          type="text"
        />
      </div>
      <div class="form-field">
        <label for="name-input">Ввести номер редакции:</label>
        <input id="name-input" v-model="newContractType.NAME" type="text" />
      </div>
    </div>
    <div class="content">
      <div class="content_title">
        Список услуг шаблона
      </div>
      <div class="content_row col-4 center bold">
        <div>Название услуги</div>
        <div>Параметры начислений</div>
        <div>Параметры пени</div>
        <div>Параметры долга и блокировки</div>
      </div>
      <div
        class="content_row col-4 center"
        v-for="(data, key) in addServicesData"
        :key="key"
      >
        <div>{{ data.service.NAME }}</div>
        <div>
          <table>
            <tr>
              <td><b>Стоимость услуги:</b></td>
              <td>{{ data.accrualRule.SUM }}</td>
            </tr>
            <tr v-show="data.accrualRule.COUNT">
              <td><b>Месяцев рассрочки:</b></td>
              <td>{{ data.accrualRule.COUNT }}</td>
            </tr>
            <tr>
              <td><b>Возможна предоплата:</b></td>
              <td>{{ data.accrualRule.PREPAYMENT_SUM }}</td>
            </tr>
            <tr>
              <td><b>Начало периода:</b></td>
              <td>{{ data.accrualRule.DATE_START }}</td>
            </tr>
            <tr>
              <td><b>Старт подсчета:</b></td>
              <td>{{ data.accrualRule.DATE_ACCRUAL }}</td>
            </tr>
          </table>
        </div>
        <div>
          <table v-if="data.service.CAN_PENALTY === 'Y'">
            <tr>
              <td><b>Процент в день: </b></td>
              <td>{{ data.penalties.PERCENT }}</td>
            </tr>
            <tr>
              <td><b>Лимит в процентах: </b></td>
              <td>{{ data.penalties.MAX }}</td>
            </tr>
          </table>

          <b v-else>Нет</b>
        </div>
        <div>
          <table v-if="data.service.CAN_DEBT === 'Y'">
            <tr>
              <td><b>Считать долг через: </b></td>
              <td>{{ data.debtAndBlock.ACTIVE_TO_DEBT }}</td>
            </tr>
            <tr>
              <td><b>Сумма долга для суда: </b></td>
              <td>{{ data.debtAndBlock.DEBT_FOR_COURT }}</td>
            </tr>
          </table>

          <b v-else>Нет</b>
        </div>
      </div>
      <div class="form-row-line">
        <div class="form-field">
          <popup-button
            button-text="Добавить услугу"
            modal-content-class="full_screen"
            :trigger="showAddService"
            v-on:toggle-show="toggleShowServicesAdd"
          >
            <add-service v-on:service-add="setServices"></add-service>
          </popup-button>
        </div>
      </div>
      <div class="form-row" v-if="info">{{ info }}</div>

      <div class="form-row">
        <div class="form-field">
          <button @click="sendTypeData">Создать редакцию шаблона</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import addService from "@/components/backoffice/org/ContractTypeServicesAdd";

export default {
  name: "ContractTypeAddRedaction",
  components: {
    addService
  },
  data() {
    return {
      showAddService: false,
      url: config.backend_url,
      villages: [],
      addServicesData: [],
      companies: [],
      newContractType: {
        PARENT_ID: this.$route.params.id,
        NAME: null,
        DESCRIPTION: null,
        COMPANY: null
      },
      info: false
    };
  },
  methods: {
    toggleShowServicesAdd: function(show) {
      this.showAddService = show;
    },
    sendTypeData: function() {
      let { newContractType } = this;
      if (
        newContractType.NAME &&
        newContractType.DESCRIPTION &&
        newContractType.COMPANY
      ) {
        let sendData = {
          serviceData: this.addServicesData,
          contractTypeData: newContractType
        };
        this.$store
          .dispatch("query/sendRequest", {
            url: this.url + "agreementtypelist/add-redaction/",
            data: sendData,
            method: "POST"
          })
          .then(response => {
            let data = response.data;
            console.log(data);
          });
      } else {
        alert("Необходимо заполнить все поля");
      }
    },
    setServices: function(data) {
      console.log(data);
      this.showAddService = false;
      this.addServicesData.push(data);
    },
    getCompanies: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "companies/get-user-companies/",
          data: {},
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) this.companies = data;
        });
    }
  },
  mounted() {
    this.getCompanies();
  }
};
</script>
